import Content from '../../components/Content';
import Hero from '../../components/Hero';
import NavigationBar from '../../components/NavigationBar';
import Footer from '../../components/Footer';
import Partners from '../../components/Partners';
import CookieBanner from '../../components/CookieBaner';

function HomePage() {
    return (
        <>
            <NavigationBar />
            <Hero />
            <Content />
            <Partners />
            <Footer />
            <CookieBanner />
        </>
    );
}
export default HomePage;